import { Route, Routes } from "react-router-dom";
import ErrorPage from "./components/Pages/ErrorPage";
import Home from "./components/Pages/Home";
import Layout from "./components/Layout/Layout";
import CreativeSolutionHome from "./components/Pages/CreativeSolutionHome";
import PrivacyPolicyPage from "./components/Pages/PrivacyPolicyPage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="creative-solution" element={<CreativeSolutionHome />} />
        <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
      </Route>
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}

export default App;
